import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        isNexus: ['client'],
        playerBaseData: undefined,
        playerCateLogList: [],
        playingSequence: -1,
        userInfos: undefined,
        themeColor: '',
        serviceName: '',
        logoURL: '',
        bannerData: [],
        globalNavsData: [],
        showLoginRegister: false,
        appDownloadUrl: '',
        navBackgroundImage:'',
        extensionURL:'',
        extensionTopURL:'',
        userLoginUrl:'/',
        userIp:'',
        navsColor:'',
        navSelectedColor:'',
        isShowResouceCount:true,
        enableCastLogin:false,
        allresoucelist:[]
    },
    mutations: {
        setAllResouceList(state, arr)
        {
            state.allresoucelist = arr;
        },
        setEnableCastLogin(state, bool)
        {
            state.enableCastLogin = bool;
        },
        setIsShowResouceCount(state, bool)
        {
            state.isShowResouceCount = bool;
        },
        setNavsColor(state, str)
        {
            state.navsColor = str;
        },
        setNavSelectedColor(state, str)
        {
            state.navSelectedColor = str;
        },
        setUserIp(state, str)
        {
            state.userIp = str;
        },
        setPlayerCateLogList (state, arr) {
            state.playerCateLogList = arr
        },
        setPlayerBaseData (state, obj) {
            state.playerBaseData = obj
        },
        setShowPlayingSequence (state, num) {
            state.playingSequence = num
        },
        setUserInfos (state, obj) {
            state.userInfos = obj
        },
        setThemeColor (state, color) {
            state.themeColor = color
        },
        setServiceName (state, str) {
            state.serviceName = str
        },
        setLogoURL (state, str) {
            state.logoURL = str
        },
        setNavBackgroundImage (state, str) {
            state.navBackgroundImage = str
        },
        setBannerData (state, arr) {
            state.bannerData = arr
        },
        setGlobalNavsData (state, arr) {
            state.globalNavsData = arr
        },
        setShowLoginRegister (state, bool) {
            let u = state.userLoginUrl.slice(0,state.userLoginUrl.indexOf("?"));
            if(u!='/'){
                window.location.href = state.userLoginUrl;
                return;
            }
            state.showLoginRegister = bool
        },
        setUserLoginUrl (state, url) {
            state.userLoginUrl = url
        },
        setAppDownloadUrl (state, str) {
            state.appDownloadUrl = str
        },
        setIsNexus (state, bool) {
            state.isNexus = bool
        },
        setExtensionURL(state, str) {
            state.extensionURL = str
        },
        setExtensionTopURL(state, str) {
            state.extensionTopURL = str
        }
    },
    actions: {
    }
})
